import { render } from "./News.vue?vue&type=template&id=b84cc84a"
import script from "./News.vue?vue&type=script&lang=ts"
export * from "./News.vue?vue&type=script&lang=ts"

import "./News.vue?vue&type=style&index=0&id=b84cc84a&lang=scss"
script.render = render

export default script